import Nullstack from 'nullstack';
export default function IconTrain({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-train",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
  }), "   ", Nullstack.element("path", {
    d: "M3 15h16a2 2 0 0 0 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 6v5h17.5"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "10",
    x2: "3",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "11",
    x2: "8",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "11",
    x2: "13",
    y2: "6.5"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "19",
    x2: "21",
    y2: "19"
  }), " ");
}